// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider, FacebookAuthProvider, GithubAuthProvider } from 'firebase/auth'; // Import getAuth, GoogleAuthProvider, FacebookAuthProvider, and GithubAuthProvider for Firebase Authentication
import { getStorage } from 'firebase/storage'; // Import getStorage for Firebase Storage

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC2SdrHB3gf1nlXsuK2Sdg4h8HlNTbvnl4",
  authDomain: "rapidmind-48128.firebaseapp.com",
  projectId: "rapidmind-48128",
  storageBucket: "rapidmind-48128.firebasestorage.app",
  messagingSenderId: "556750853425",
  appId: "1:556750853425:web:1f0d4491d7703f8b1dcc10",
  measurementId: "G-8MLBYTVHL9"
};

// Google Client ID for Google Sign-In
export const GOOGLE_CLIENT_ID = "556750853425-79gci4eqdu899vo8tuj2pqlhsdn08p4b.apps.googleusercontent.com";

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account',
  redirect_uri: 'https://rapid-mind.com'
});

// Initialize Facebook Auth Provider
export const facebookProvider = new FacebookAuthProvider();

// Initialize GitHub Auth Provider
export const githubProvider = new GithubAuthProvider();

// Export Firebase services
export const db = getFirestore(app); // Export Firestore instance
export const auth = getAuth(app);   // Export Auth instance
export const storage = getStorage(app); // Export Storage instance

export default app;
